/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import * as styles from "./CardAsLink.module.scss";

const CardAsLink = ({ className, link, target, text, renderLink }) => {
	const Tag = `${renderLink}`;
	return (
		<Tag className={cx(styles.cardLink, className)} to={link} target={target} title={text}>
			<span className={styles.srOnly}>{text}</span>
		</Tag>
	);
};

CardAsLink.propTypes = {
	className: PropTypes.string,
	link: PropTypes.string.isRequired,
	target: PropTypes.string,
	text: PropTypes.string,
	renderLink: PropTypes.elementType,
};

CardAsLink.defaultProps = {
	className: undefined,
	target: "_self",
	text: undefined,
	renderLink: undefined,
};

export default CardAsLink;
export { CardAsLink };
